import { call, put, takeLatest } from 'redux-saga/effects';
import { PostTopics } from 'services/api';
import {
  updatePostTopic,
  updatePostTopicSuccess,
  updatePostTopicFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* updatePostTopicSaga(action) {
  try {
    const data = yield call(PostTopics.updatePostTopic, action.payload);
    yield put(updatePostTopicSuccess(data));
    yield put(
      notificationActions.addNotification([
        { type: 'success', message: { code: 'saved', resource: 'changes' } },
      ])
    );
  } catch (e) {
    yield put(updatePostTopicFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(updatePostTopic, updatePostTopicSaga);
